export const convertTextFieldErrorMessage = (
  localeTexts: Record<string, string>,
  error: string | undefined,
  value: string | number,
  name?: string
): string | undefined => {
  const text = value.toString().split('@')[1]
  switch (error) {
    case 'Please fill out this field.':
      return localeTexts['input-validate-required-text']
    case `Please include an '@' in the email address. '${value}' is missing an '@'.`:
      return localeTexts['input-validate-email-text']
    case `Please enter a part following '@'. '${value}' is incomplete.`:
      return localeTexts['input-validate-email-text']
    case `'.' is used at a wrong position in '${text}'.`:
      return localeTexts['input-validate-email-text']
    case 'Please match the requested format.':
      return (name === 'phone' || name === 'mobile') ? localeTexts['input-validate-mobile-text'] : error
    default:
      return error
  }
}
